interface OrderMatch {
  id: number;
  order_number?: string | null;
  customer_name?: string | null;
}

export async function linkFeedbackByOrderNumber(
  feedbackId: number,
  input: string,
  api: {
    dispatch: (orderNumber: string) => Promise<{ exists: boolean; order?: OrderMatch }>;
    link: (feedbackId: number, dealId: number) => Promise<unknown>;
  },
  confirm: (message: string) => boolean | Promise<boolean>
): Promise<boolean> {
  const orderNumber = input.trim().toUpperCase();
  if (!orderNumber) throw new Error('Enter an order number.');
  const result = await api.dispatch(orderNumber);
  if (!result.exists || !result.order) {
    throw new Error('Order not found or not accessible. Check the order number and your team access.');
  }
  const order = result.order;
  if (order.order_number !== orderNumber || !Number.isSafeInteger(order.id) || order.id <= 0) {
    throw new Error('Order lookup returned an invalid match. Feedback was not linked. Please retry the lookup.');
  }
  if (!await confirm(`Link feedback #${feedbackId} to order ${order.order_number} · ${order.customer_name || 'Customer name not recorded'}?`)) return false;
  await api.link(feedbackId, order.id);
  return true;
}
